import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IFmlmFavouriteLocationAtom } from "../../../Orchestrator/Recoils/LocationAtom";
import { IFmlmMile } from "../../../Orchestrator/Types/Index";

export const getFmlmFavouritesFromLocalStorage = (selectedExactLocation: string): Promise<IFmlmMile | null> => {
  return new Promise<IFmlmMile | null>((resolve, reject) => {
    try {
      let key = selectedExactLocation === "origin" ? "fmlmOriginFavourites" : "fmlmDestinationFavourites";

      const fmlmFavourites = localStorage.getItem(key);

      if (fmlmFavourites) {
        const parsedFavourites: IFmlmMile = JSON.parse(fmlmFavourites);
        resolve(parsedFavourites);
      } else {
        resolve(null);
      }
    } catch (error) {
      console.error("Error retrieving FMLM favourites from local storage:", error);
      reject(error);
    }
  });
};

export const hydrateFmlmFavouritesFromLocalStorageToAtom = async () => {
  try {
    const fmlmFavouritesOrigin = await getFmlmFavouritesFromLocalStorage("origin");
    const fmlmFavouritesDestination = await getFmlmFavouritesFromLocalStorage("destination");

    updateRecoilState<IFmlmFavouriteLocationAtom>("fmlmFavouriteLocationAtom", {
      firstMile: fmlmFavouritesOrigin || { latitude: 0, longitude: 0, name: "" },
      lastMile: fmlmFavouritesDestination || { latitude: 0, longitude: 0, name: "" }
    });

  } catch (error) {
    console.error("Error hydrating FMLM favourites from local storage:", error);
  }
}

class SaveFmlmFavouritesToLocalStorageAction extends BaseAction<void, {
  selectedExactLocation: string;
  fmlmMile?: IFmlmMile;
}> {
  static readonly type = '[FMLM] Get Favourites from Local Storage';

  override async run(): Promise<void> {
    try {
      const { selectedExactLocation, fmlmMile } = this.params!;

      let key = selectedExactLocation === "origin" ? "fmlmOriginFavourites" : "fmlmDestinationFavourites";
      localStorage.setItem(key, JSON.stringify(fmlmMile || ""));
    } catch (error) {
      console.error("Error saving FMLM favourites to local storage:", error);
    }
  }

}

export const saveFmlmFavouritesToLocalStorage = new SaveFmlmFavouritesToLocalStorageAction();
